import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/packages/blue-book-player/library/modal/ConfirmDialog';

const AutoSubmitDialog = (props) => {
  const { onClose } = props;

  return (
    <ConfirmDialog
      title="Assessment Submitted"
      onClose={onClose}
      onSuccess={onClose}
      aria={{
        'aria-live': 'polite',
      }}
      content={{
        btnPrimary: 'Ok',
      }}
      size="medium"
    >
      <div className="flex flex-col gap-8">
        <p className="m-0">
          The assessment has been submitted, either because its due date has
          passed or your teacher has manually submitted it.
        </p>
        <p className="m-0">
          Your progress has been saved and your assignment has been submitted.
        </p>
      </div>
    </ConfirmDialog>
  );
};

AutoSubmitDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AutoSubmitDialog;
